var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tab',[_c('Panel',{attrs:{"rounded-corners":false}},[_c('h2',{staticClass:"visible-xs-block",attrs:{"slot":"head"},slot:"head"},[_c('span',[_c('svgicon',{attrs:{"icon":"envelope","width":"23","height":"22","original":true}})],1),_c('strong',[_vm._v("Contact Us")])]),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('ContactMe')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }